import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'order-executions',
  action: ActionType.READ,
};

const readPermission = {
  resource: 'order-execution',
  action: ActionType.READ,
};

export const OrderExecution = {
  list: listPermission,
  read: readPermission,
};
